import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useConsent } from "@/contexts/ConsentContext";

export function Footer() {
    const { openPreferences } = useConsent();
    return (
        <footer className="mt-20 border-t" style={{ borderColor: "var(--ok-border)" }} data-testid="site-footer">
            <div className="ok-container py-10 grid grid-cols-2 md:grid-cols-5 gap-8">
                <div className="col-span-2 md:col-span-2 space-y-3">
                    <Logo size={32} />
                    <p className="text-xs opacity-60 max-w-sm leading-relaxed">
                        Real encounters. Hidden patterns. The truth in plain sight.
                    </p>
                </div>
                <div className="space-y-2">
                    <div className="font-mono text-[10px] uppercase tracking-widest opacity-50">Archive</div>
                    <Link to="/encounters" className="block text-sm hover:text-[var(--ok-accent)]">All encounters</Link>
                    <Link to="/encounters?source_type=historical" className="block text-sm hover:text-[var(--ok-accent)]">Historical cases</Link>
                    <Link to="/map" className="block text-sm hover:text-[var(--ok-accent)]">Encounter map</Link>
                    <Link to="/timeline" className="block text-sm hover:text-[var(--ok-accent)]">Timeline</Link>
                    <Link to="/universe" className="block text-sm hover:text-[var(--ok-accent)]">Universe</Link>
                    <Link to="/species" className="block text-sm hover:text-[var(--ok-accent)]">Species</Link>
                </div>
                <div className="space-y-2">
                    <div className="font-mono text-[10px] uppercase tracking-widest opacity-50">Contribute</div>
                    <Link to="/lodge" className="block text-sm hover:text-[var(--ok-accent)]">Lodge encounter</Link>
                    <Link to="/pricing" className="block text-sm hover:text-[var(--ok-accent)]">Become founding witness</Link>
                    <Link to="/signup" className="block text-sm hover:text-[var(--ok-accent)]">Create account</Link>
                </div>
                <div className="space-y-2">
                    <div className="font-mono text-[10px] uppercase tracking-widest opacity-50">Project</div>
                    <Link to="/about" className="block text-sm hover:text-[var(--ok-accent)]">About</Link>
                    <Link to="/contact" className="block text-sm hover:text-[var(--ok-accent)]">Contact</Link>
                    <Link to="/privacy" className="block text-sm hover:text-[var(--ok-accent)]" data-testid="footer-privacy-link">Privacy</Link>
                    <Link to="/cookie-policy" className="block text-sm hover:text-[var(--ok-accent)]" data-testid="footer-cookie-link">Cookie policy</Link>
                    <button
                        onClick={openPreferences}
                        className="block text-sm hover:text-[var(--ok-accent)] text-left"
                        data-testid="footer-manage-cookies"
                    >
                        Manage cookies
                    </button>
                </div>
            </div>
            <div className="ok-container py-4 border-t font-mono text-[10px] uppercase tracking-widest opacity-50 flex flex-wrap justify-between gap-2"
                 style={{ borderColor: "var(--ok-border)" }}>
                <span>© 2026 Project UNVEILED · Official site release: June 2026</span>
                <span>Truth · Witness · Record</span>
            </div>
        </footer>
    );
}
